module.exports = __webpack_public_path__ + "static/media/logo_sendero.775da638.gif";